export default "__VITE_ASSET__CyobJxKE__"